import React, { Component } from "react";
import CorteCajaTablaUsuarioAlta from "./CorteCajaTablaUsuarioAlta";
import CorteCajaTablaUsuarioAltaGasto from "./CorteCajaTablaUsuarioAltaGasto";

import CorteCajaTablaTipoPago from "./CorteCajaTablaTipoPago";
import CorteCajaTablaConceptoCobro from "./CorteCajaTablaConceptoCobro";
import CorteCajaTablaUsuarioComisiones from "./CorteCajaTablaUsuarioComisiones";

import CorteCajaTablaUsuarioConsolidado from "./CorteCajaTablaUsuarioConsolidado";


import { connect } from "react-redux";
import FormCorteCaja from "./FormCorteCaja";
import { getPagoPorConceptoCobroPorUsuario, getPagoPorUsuarioAltaPorUsuario, getPagoPorTipoPagoPorUsuario, getCobroPorUsuario, getComisionesPorUsuario, getConsolidadoPorUsuario, putCerrarCorteCaja } from './AlumnoAction'
import { withRouter } from 'react-router-dom';

import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'



import { Container } from "reactstrap";

import swal from "sweetalert";

import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import { Link } from "react-router-dom";


import ToolTip from "../../common/toolTip";


const mapStateToProps = (state) => {
    //console.log("AAAAAA "+state.AlumnoReducer.getResponDataAlumno);
    return {
        getResponDataAlumno: state.AlumnoReducer.getResponDataAlumno,
        errorResponDataAlumno: state.AlumnoReducer.errorResponDataAlumno,
    };
};


class CorteCajaContainerR extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            show: false,
            isCardRemove: false,
            isFullScreen: false,
            isCollapsed: false,
            isCollapsed2: false,
            isCollapsed3: false,
        };
    }

    componentDidMount() {
        var f           = new Date();
        var fechaactual = (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate());
        var id          = parseInt(sessionStorage.getItem('idusuario'));

        this.props.dispatch(getPagoPorConceptoCobroPorUsuario(id));
        this.props.dispatch(getPagoPorUsuarioAltaPorUsuario(id));
        this.props.dispatch(getPagoPorTipoPagoPorUsuario(id));

        this.props.dispatch(getCobroPorUsuario(id));

        this.props.dispatch(getComisionesPorUsuario(id));

        this.props.dispatch(getConsolidadoPorUsuario(id));


        //console.log("AlumnoContainer");
        //this.props.dispatch(getPagoPorConceptoCobro(fechaactual, fechaactual));
        //this.props.dispatch(getPagoPorUsuarioAlta(fechaactual, fechaactual));
        //this.props.dispatch(getPagoPorTipoPago(fechaactual, fechaactual));

    }

    handleSubmit(data) {
        var id = parseInt(sessionStorage.getItem('idusuario'));
        this.props.dispatch(putCerrarCorteCaja(data,id));
    }

    render() {
        const { activeTab } = this.state
        const { dropDownMenu, dropDownMenuAction } = this.props
        const { isCardRemove, isFullScreen, isCollapsed, isCollapsed2, isCollapsed3 } = this.state

        //console.log("AAAAA ---->" + this.props.getResponDataAlumno);

        if (this.props.getResponDataAlumno || this.props.errorResponDataAlumno) {

            if (this.props.errorResponDataAlumno) {
                swal("Fallido!", this.props.errorResponDataAlumno, "Error");
            } else {
                swal({
                    title: "¡Caja Cerrada!",
                    icon: "success",
                    button: "Enterado"
                }
                )
                    .then((willDelete) => {
                        this.props.history.push("/alumno");
                    });
            }//END ELSE

        }//END IF



        return (
            <MuiThemeProvider muiTheme={getMuiTheme()}>
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Alumno</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Escolar</a></li>
									<li className="breadcrumb-item active" aria-current="page">Cobro</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<Link to={"/alumno"}>Listar Alumno</Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

					

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>
							<TabPane tabId={1} className={classnames(['fade show'])}>

                                    <div className="row">
                                        

                                        <div className="col-xl-6 col-md-6">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">Por Concepto De Pago</h3>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed: !isCollapsed })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }
                                                       
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <CorteCajaTablaConceptoCobro />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-6 col-md-6">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed2 ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">Por Tipo De Pago</h3>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed2: !isCollapsed2 })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <CorteCajaTablaTipoPago />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-6 col-md-6">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed3 ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">Por Usario Del Sistema</h3>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed3: !isCollapsed3 })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <CorteCajaTablaUsuarioAlta />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-xl-6 col-md-6">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed3 ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">Comisiones / I.V.A</h3>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed3: !isCollapsed3 })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <CorteCajaTablaUsuarioComisiones />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-xl-6 col-md-6">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed3 ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h6 className="card-title" style={{ color: "red" }}>GASTOS POR USUARIO</h6>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed3: !isCollapsed3 })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <CorteCajaTablaUsuarioAltaGasto />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-xl-6 col-md-6">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed3 ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">CONSOLIDADO POR USUARIO</h3>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed3: !isCollapsed3 })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <CorteCajaTablaUsuarioConsolidado />
                                                </div>
                                            </div>
                                        </div>

                                    </div>


								<FormCorteCaja onSubmit={(data) => this.handleSubmit(data)} />
							</TabPane>

							
						</TabContent>
					</div>
				</div>

					
			</>
			</MuiThemeProvider>

        );
    }
}
export default withRouter(connect(mapStateToProps, null)(CorteCajaContainerR));
